(function FAQ(SectionsDesign) {
  'use strict';
  
  if (SectionsDesign.faq) return;
  SectionsDesign.faq = {};
  
  var support = getSupport();
 
  var init = function() {
    var configNodes = Array.from(document.querySelectorAll('[data-faq-config]'));
    
    configNodes.map(configNode => {
      var section = compose(publicAPI, setEvents, getBlocks, getConfig)(configNode);
      SectionsDesign.faq[section.id] = section;
    });
    
    // Also initialize any bulk FAQs that might already exist
    initializeExistingBulkFAQs();
  }
  
  init();
  
  // Function to initialize bulk FAQs that already exist in the DOM
  function initializeExistingBulkFAQs() {
    var bulkFAQTriggers = document.querySelectorAll('[data-faq-trigger^="bulk-faq-"]');
    bulkFAQTriggers.forEach(function(trigger) {
      var triggerId = trigger.getAttribute('data-faq-trigger');
      var button = document.querySelector('[data-faq-button="' + triggerId + '"]');
      var panel = document.querySelector('[data-faq-panel="' + triggerId + '"]');
      
      if (button && panel && !button.hasAttribute('data-faq-init')) {
        var block = {
          trigger: trigger,
          button: button,
          panel: panel,
          get collapsed() { return isCollapsed(this) }
        };
        blockEvents(block);
      }
    });
  }
  
  // Expose function to initialize new bulk FAQs
  window.initializeBulkFAQItem = function(triggerId) {
    var trigger = document.querySelector('[data-faq-trigger="' + triggerId + '"]');
    var button = document.querySelector('[data-faq-button="' + triggerId + '"]');
    var panel = document.querySelector('[data-faq-panel="' + triggerId + '"]');
    
    if (trigger && button && panel && !button.hasAttribute('data-faq-init')) {
      var block = {
        trigger: trigger,
        button: button,
        panel: panel,
        get collapsed() { return isCollapsed(this) }
      };
      blockEvents(block);
      return block;
    }
    return null;
  };
 
  function publicAPI(config) {
    return {
      id: config.sectionId,
      config: config,
      blocks: zipObj(config.blockIds, config.blocks),
      init: init
    }
  }

  //**************************


  /**
   * Click event.
   * @param {Object} block Section block elements and methods.
   * @return {Object} Section block elements and methods.
   */
  function blockEvents(block) {
    // Skip blocks that don't have valid content
    if (!block || !block.trigger || !block.button || !block.panel) return block;
    if (block.trigger.hasAttribute('data-faq-init')) return block;
    
    block.trigger.setAttribute('data-faq-init', true);
    block.trigger.addEventListener('click', triggerClick);
                                   
    function triggerClick() {
      toggle(block);
    }

    return block;
  }

  /**
   * Toggle block state.
   * @param {Object} block Section block elements and methods.
   * @return {Object} Section block elements and methods.
   */
  function toggle(block) {
    block.collapsed ? expand(block) : collapse(block);
    return block;
  }
  
  /**
   * Expand block.
   * @param {Object} block Section block elements and methods.
   * @return {Object} Section block elements and methods.
   */
  function expand(block) {
    block.button.setAttribute('aria-expanded', true);
    block.panel.removeAttribute('hidden');
    animate(block.panel, 'normal');
    return block;
  }
  
  /**
   * Collapse block.
   * @param {Object} block Section block elements and methods.
   * @return {Object} Section block elements and methods.
   */
  function collapse(block) {
    block.button.setAttribute('aria-expanded', false);
    block.panel.setAttribute('hidden', '');
    animate(block.panel, 'reverse');
    return block;
  }
  
  /**
   * Check if block is collapsed.
   * @param {Object} block Section block elements and methods.
   * @return {boolean} Collapsed block state.
   */
  function isCollapsed(block) {
    return Boolean(block.button.getAttribute('aria-expanded') === 'false');
  }

  /**
   * Animate FAQ panel.
   * @param {HTMLElement} element Block panel element to animate.
   * @param {String} direction Animation direction, normal or reverse.
   * @return {undefined} Nothing to return.
   */
  function animate(element, direction) { 
    if (!support.WebAnimations) return;

    element.setAttribute('data-is-animating', true);

    element.animate([
      { height: 0 },
      { height: element.offsetHeight + 'px' }],

      { duration: 240,
        fill: 'both',
        easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
        direction: direction
      }

    ).onfinish = function() {
      element.removeAttribute('data-is-animating');
      this.cancel();
    };
  }

  //**************************


  /**
   * Maps all block IDs to exposed block API.
   * @param {Object} config Section and section blocks IDs.
   * @return {Object} config Section and section blocks IDs.
   */
  function getBlocks(config) {
    // Filter out invalid block IDs and create only valid blocks
    config.blocks = config.blockIds
      .map(block)
      .filter(function(blockObj) {
        // Only include blocks that have all required elements and content
        return blockObj && 
               blockObj.trigger && 
               blockObj.button && 
               blockObj.panel &&
               hasValidContent(blockObj);
      });
    return config;
  }

  /**
   * Check if a block has valid content
   * @param {Object} blockObj Block object with trigger, button, panel
   * @return {Boolean} Whether the block has valid content
   */
  function hasValidContent(blockObj) {
    if (!blockObj.button) return false;
    
    // Get the question text from the button
    var buttonSpan = blockObj.button.querySelector('span');
    if (!buttonSpan) return false;
    
    var questionText = buttonSpan.textContent || buttonSpan.innerText || '';
    questionText = questionText.trim();
    
    // Get the answer text from the panel
    var panelWrap = blockObj.panel.querySelector('.faq-wrap');
    if (!panelWrap) return false;
    
    var answerText = panelWrap.textContent || panelWrap.innerText || '';
    answerText = answerText.trim();
    
    // Only show blocks with meaningful content (more than 2 characters)
    return questionText.length > 2 && answerText.length > 2;
  }

  /**
   * Create section block API.
   * @param {String} blockId Section Liquid block ID.
   * @return {Object|null} block elements and methods, or null if invalid.
   */
  function block(blockId) {
    var trigger = document.querySelector('[data-faq-trigger="' + blockId + '"]');
    var button = document.querySelector('[data-faq-button="' + blockId + '"]');
    var panel = document.querySelector('[data-faq-panel="' + blockId + '"]');
    
    // Return null if any essential element is missing
    if (!trigger || !button || !panel) {
      // If elements exist but are empty, hide them
      if (trigger) trigger.style.display = 'none';
      if (panel) panel.style.display = 'none';
      return null;
    }
    
    return {
      trigger: trigger,
      button: button,
      panel: panel,

      get collapsed() { return isCollapsed(this) },
      select: function select() { return expand(this) },
      deselect: function deselect() { return collapse(this) }
    }
  }

  /**
   * Adds event listeners to block elements.
   * @param {Object} config Section and section blocks IDs.
   * @return {Object} config Section and section blocks IDs.
   */
  function setEvents(config) {
    config.blocks.forEach(blockEvents);
    return config;
  }

  /**
   * Pass the Liquid assigned section variables.
   * @param {HTMLElement} element Configuration script node.
   * @return {Object} Section and section blocks IDs.
   */
  function getConfig(node) {
    return JSON.parse(node.innerHTML);
  }

  /**
   * Feature detection.
   * @return {Object} Browser support.
   */
  function getSupport() {
    return {
      WebAnimations: (typeof Element.prototype.animate === 'function')
    }
  }

  //**************************


  /**
   * Creates a new object out of a list of keys and a list of values.
   * Key/value pairing is truncated to the length of the shorter of the two lists.
   * @example
   *    zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
   * @param {Array} keys The array that will be properties on the output object.
   * @param {Array} values The list of values on the output object.
   * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
   */
  function zipObj(keys, values) {
    return keys.reduce(
      function zipObj(acc, key, idx) {
        acc[key] = values[idx];
        return acc;
      }, {}
    )
  }

  /**
   * Performs right-to-left function composition.
   * The rightmost function may have any arity, the remaining functions must be unary.
   * @example
   *   function plus1(n) {return n + 1};
   *   function plus2(n) {return n + 2};
   *   compose(plus2,plus1)(1) => 4
   * @return {Function} Composed function
   */
  function compose() {
    var funcs = Array.prototype.slice.call(arguments).reverse();
    return function() {
      return funcs.slice(1).reduce(function(res, fn) {
        return fn(res);
      }, funcs[0].apply(undefined, arguments));
    };
  }
  
})(window.SectionsDesign = window.SectionsDesign || {});